module.exports = __webpack_public_path__ + "media/components/page-footer/static/weather-forecast__logo--white-fbe1dfc854535d13bfdf051555830c64.png";